// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_72258","quote":"_26ed8","author":"_52b75","text":"ec64e"};